<template lang="pug">

  section.gal
    img(v-for="(pic, index) in pics" :src="pic" alt="" :key="index")

</template>

<script>
  export default  {
    name: 'Gal',
    props: {
      pics: {
        type: Array,
        default: function() {
          return ["assets/images/_MG_4212.jpg","assets/images/_MG_4260.jpg"]
        }
      }
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .gal {
    transition: all .3s;
    filter: grayscale(100%);
    &:hover{
      filter: grayscale(0);
    }
  }
</style>
